import React from 'react';
import Modal from 'react-modal';
import MaskedInput from 'react-text-mask';

Modal.setAppElement(document.getElementById('root'));
const CardPopup = ({ phone, setPhone, modalIsOpen, closeModal }) => {
  let success = false;
  let error = false;
  return (
    <Modal
      isOpen={modalIsOpen}
      contentLabel="CTA Modal"
      onRequestClose={closeModal}
      className="card-popup"
      overlayClassName="popup-wrapper"
    >
      <h3>Мы вам позвоним</h3>
      <div className="popup-action">
        {success && (
          <p className="success">
            Ваш номер телефона был успешно отправлен. В ближайшее время мы
            свяжемся с вами.
          </p>
        )}
        {error && (
          <p className="error">
            К сожалению, номер телефона не удалось отправить. Попробуйте
            повторить отправку чуть позже.
          </p>
        )}
        <p>
          Оставьте, пожалуйста, свой номер телефона. <br />
          Наш флорист перезвонит и проконсультирует по цветам и доставке.
        </p>
        <form>
          <MaskedInput
            mask={[
              '(',
              /[1-9]/,
              /\d/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              ' ',
              /\d/,
              /\d/,
              ' ',
              /\d/,
              /\d/,
            ]}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <button onClick={(e) => e.preventDefault()}>Перезвоните мне</button>
        </form>
      </div>
    </Modal>
  );
};

export default CardPopup;
